<template functional>
    <span :class="['dml-radio', { 'dml-radio--selected': props.isSelected }]">
        <div :class="props.count && 'dml-radio__wrapper'">
            <span>
                {{props.name}}
            </span>
            <span v-if="props.count" class="dml-radio__count">
                ({{props.count}})
            </span>
        </div>
    </span>
</template>
<script>
    export default {
        name: 'dm-radio',
        props: {
            name: {
                type: String,
                required: true
            },
            isSelected: {
                type: Boolean,
                default: false
            },
            count: {
                type: Number,
                required: false
            },
        }
    };
</script>
